
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserTable } from '@/components/UserTable';
import AddUserDialog from '@/components/admin/user-management/AddUserDialog';
import { useRolePermissions } from '@/hooks/useRolePermissions';
import { useLanguage } from '@/contexts/LanguageContext';
import { useUserManagement } from '@/components/admin/user-management/hooks/useUserManagement';

const UsersManager: React.FC = () => {
  const { direction } = useLanguage();
  const { isAdminOrHigher } = useRolePermissions();
  const {
    isAddDialogOpen,
    setIsAddDialogOpen,
    newUserEmail,
    setNewUserEmail,
    newUserPassword,
    setNewUserPassword,
    isSubmitting,
    handleAddUser: originalHandleAddUser
  } = useUserManagement();

  // Create a wrapper function with the correct signature
  const handleAddUser = async (e: React.FormEvent) => {
    e.preventDefault();
    await originalHandleAddUser(e);
  };

  return (
    <div className="space-y-6">
      <div className={`flex justify-between items-center ${direction === 'rtl' ? 'flex-row-reverse' : ''}`}>
        <div className={direction === 'rtl' ? 'text-right' : 'text-left'}>
          <h1 className="text-3xl font-bold tracking-tight">ניהול משתמשים</h1>
          <p className="text-muted-foreground">ניהול משתמשים והרשאות</p>
        </div>
        {isAdminOrHigher && (
          <Button onClick={() => setIsAddDialogOpen(true)}>הוספת משתמש</Button>
        )}
      </div>

      <Card>
        <CardHeader className={direction === 'rtl' ? 'text-right' : 'text-left'}>
          <CardTitle>משתמשים</CardTitle>
          <CardDescription>
            צפייה וניהול של כל המשתמשים במערכת
          </CardDescription>
        </CardHeader>
        <CardContent>
          <UserTable />
        </CardContent>
      </Card>

      <AddUserDialog 
        isOpen={isAddDialogOpen}
        onOpenChange={setIsAddDialogOpen}
        newUserEmail={newUserEmail}
        setNewUserEmail={setNewUserEmail}
        newUserPassword={newUserPassword}
        setNewUserPassword={setNewUserPassword}
        handleAddUser={handleAddUser}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default UsersManager;
